import { render, staticRenderFns } from "./quickTraineeReg.vue?vue&type=template&id=115db6e6&scoped=true"
import script from "./quickTraineeReg.vue?vue&type=script&lang=js"
export * from "./quickTraineeReg.vue?vue&type=script&lang=js"
import style0 from "./quickTraineeReg.vue?vue&type=style&index=0&id=115db6e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115db6e6",
  null
  
)

export default component.exports